export const GET_INDEXES_REQUESTED = "GET_INDEXES_REQUESTED";
export const GET_INDEXES_SUCCEEDED = "GET_INDEXES_SUCCEEDED";
export const GET_INDEXES_FAILED = "GET_INDEXES_FAILED";

export const GET_INDEX_REQUESTED = "GET_INDEX_REQUESTED";
export const GET_INDEX_SUCCEEDED = "GET_INDEX_SUCCEEDED";
export const GET_INDEX_FAILED = "GET_INDEX_FAILED";
